module.exports = __webpack_public_path__ + "static/media/18.16c216cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/18.png
// module id = 1123
// module chunks = 0